import React from "react";
import { Typography, Box } from "@mui/material";

const Footer = () => {
  return (
    <Box sx={{ py: 2, textAlign: "center", bgcolor: "#f9f9f9" }}>
      <Typography
        variant="caption"
        sx={{
          fontFamily: "Poppins, sans-serif",
          fontSize: "13px",
          fontWeight: 500,
        }}
      >
        All rights reserved ©Backbenchers: Turning Ideas Into Digital Reality &nbsp;{new Date().getFullYear()}
      </Typography>
    </Box>
  );
};

export default Footer;
